import { render, staticRenderFns } from "./solicitudes.vue?vue&type=template&id=c4df62e2&scoped=true"
import script from "./solicitudes.vue?vue&type=script&lang=js"
export * from "./solicitudes.vue?vue&type=script&lang=js"
import style0 from "./solicitudes.vue?vue&type=style&index=0&id=c4df62e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4df62e2",
  null
  
)

export default component.exports